import script from "./ModalHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ModalHeader.vue?vue&type=style&index=0&id=5086798a&lang=scss"

const __exports__ = script;

export default __exports__